<div class="card md:min-w-[500px]">
  <div class="card-header"> {{data.title}} </div>
  <div class="card-body">
    <mat-dialog-content>
      <p *ngFor="let msg of getMessages" class="{{data.messageType}}">{{msg}}</p>
      <p *ngIf="data.link">
        <a [href]="data.link.url" target="_blank" rel="noopener" class="underline text-blue-600">
          <i class="fal fa-arrow-up-right-from-square"></i> {{data.link.label}}
        </a>
      </p>
    </mat-dialog-content>
  </div>
  <div class="card-footer">
    <div class="flex flex-row-reverse justify-between items-center mb-4">
      <button *ngIf="!data.disableClodeButton&&!(isTokenExpired$|async)" (click)="onClose()" class="custom-button">
        Close
      </button>
      <button *ngIf="isTokenExpired$|async" (click)="loginS.logout()" mat-dialog-close
        class="custom-button custom-button-primary">
        Logout
      </button>
    </div>
  </div>
</div>